import isNil from 'lodash-es/isNil';
import { capitalize } from 'src/app/utils/string.utils';

export function yesNo(value: string, capitalized = false): string {
    const capitalizeResult = (input: string): string => capitalized ? capitalize(input) : input;
    const result = anyToBoolean(value) ? 'oui' : 'non';

    return capitalizeResult(result);
}

export function anyToBoolean(value: any): boolean {
    if (isNil(value)) {
        return false;
    }

    const trueValues = ['yes', 'true', 'oui', '1'];
    if (trueValues.includes(value.toString().toLowerCase())) {
        return true;
    }
    const falseValues = ['no', 'false', 'non', '0'];
    if (falseValues.includes(value.toString().toLowerCase())) {
        return false;
    }
    return !!value;
}
